import { configureStore } from '@reduxjs/toolkit';
import gamificationReducer from './slices/gamificationSlice';

export const store = configureStore({
  reducer: {
    gamification: gamificationReducer,
  },
});

export default store;
